module.exports = __webpack_public_path__ + "static/media/c_0.c6a1d5c7.png";